var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpi-avatar-stack d-flex",staticStyle:{"margin-left":"8px"}},_vm._l((_vm.avatars),function(avatar,i){return _c('div',{key:i,style:({
            width: '32px',
            height: '32px',
            borderRadius: '9999px',
            border: '2px solid #fff',
            background: avatar.color,
            color: avatar.text,
            fontSize: '10px',
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: i === 0 ? '0' : '-8px',
        })},[_vm._v(" "+_vm._s(avatar.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }